module.exports = __webpack_public_path__ + "static/media/country_lu.1175a1b9.webp";